import React from 'react';
import styled from 'styled-components';
import ModalButton from '../modal/Modal_button';
import ModalBg from '../modal/Modal_bg';

//날짜 출력 폼 형태
function getDateType(date) {
  function checkZero(checkString) {
    return checkString.toString().length === 1 ? '0' + checkString : checkString;
  }
  var temp = `${checkZero(date.getMonth() + 1)}/${checkZero(date.getDate())}`;
  return temp;
}

export default function ModalText({
  textModalShow,
  setTextModalShow,
  modalOption,
  submitClick,
  startDate,
  setModalOption,
}) {
  const modalStateList = {
    delete: {
      title: '게시글 삭제',
      subtitle: '작성한 게시글이 삭제됩니다. 정말 삭제 하시겠어요?',
    },
    cancle: {
      title: '게시물 작성 취소 ',
      subtitle: '게시물 작성을 취소하시겠어요? ',
    },
    routinetxt: {
      title: '루틴 갯수 제한',
      subtitle: '루틴은 5개까지 추가 가능해요.',
    },
    leave: {
      title: '탈퇴하기',
      subtitle:
        '회원님이 개설한 모임/프로젝트의 정보가 \n 모두 사라집니다.정말 탈퇴하시겠어요?',
    },
    routineSeletboth: { subtitle: '루틴 시작날짜, 요일을 설정해 주세요' },
    routineSeletDay: { subtitle: '루틴 시작날짜를 설정해 주세요' },
    routineSeletWeek: { subtitle: '루틴 요일을 설정해 주세요' },
    todolistChangeCalcel: {
      title: '투두리스트 수정 취소 ',
      subtitle: '투두리스트 수정을 취소하시겠어요? ',
    },
    todolistChangeDel: {
      title: '투두리스트 삭제 ',
      subtitle: '투두리스트를 삭제하시겠어요?',
    },
    campaignjoinDay: {
      title: '오픈 프로젝트 참여하기 ',
      subtitle: `이 캠페인은 ${getDateType(
        new Date(startDate),
      )}일부터 시작됩니다. 시작이 되면 알려드릴게요!`,
    },
    campaignjoin: {
      title: '오픈 프로젝트 참여하기 ',
      subtitle:
        '이 캠페인은 오늘부터 시작합니다. 투두리스트를 꼭 인증해 주세요.',
    },
    campaignleave: {
      title: '오픈 프로젝트 참여취소 ',
      subtitle: '오픈 프로젝트 참여를 취소하시겠어요?',
    },
    groupleave: {
      title: '모임 탈퇴하기 ',
      subtitle:
        '모임을 탈퇴하시면 진행중인 프로젝트가 / 중단됩니다. 지금 탈퇴하시겠어요?',
    },
    groupjoin: {
      title: '모임 가입하기 ',
      subtitle: '모임에 가입하시면 진행중인 프로젝트에 참여하실 수 있어요!',
    },
    projectjoinDay: {
      title: '프로젝트 참여하기 ',
      subtitle: `이 프로젝트는 ${getDateType(
        new Date(startDate),
      )}일부터 시작됩니다. 시작이 되면 알려드릴게요!`,
    },
    projectjoin: {
      title: '프로젝트 참여하기 ',
      subtitle:
        '이 프로젝트는 오늘부터 시작합니다. 투두리스트를 꼭 인증해 주세요.',
    },
    projectleave: {
      title: '프로젝트 참여취소 ',
      subtitle: '프로젝트 참여를 취소하시겠어요?',
    },
    routineDel: {
      title: '루틴 삭제 ',
      subtitle:
        '루틴을 삭제하시면 더이상 투두리스트에 보여지지 않습니다. 루틴을 삭제하시겠어요? ',
    },
    login: { subtitle: '로그인이 필요해요' },
  };

  if (
    textModalShow === true &&
    modalOption !== '' &&
    !modalStateList[modalOption]
  ) {
    //alert('우리님 위에 데이터 채워주세요');
    return null;
  }

  return textModalShow ? (
    <div>
      <ModalBg background={'rgba(0,0,0,0.6)'} />
      <Modal>
        <ModalTitle>
          {modalStateList[modalOption] ? modalStateList[modalOption].title : ''}
        </ModalTitle>
        <ModalContentInner>
          {modalStateList[modalOption]
            ? modalStateList[modalOption].subtitle
            : ''}
        </ModalContentInner>
        <ModalButton
          setModalOption={setModalOption}
          setShowModal={setTextModalShow}
          submitClick={submitClick}
        />
      </Modal>
    </div>
  ) : null;
}

const Modal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100vw * (284 / 375));
  border-radius: calc(100vw * (10 / 375));
  background-color: #ffffff;
  z-index: 500;
`;
const ModalTitle = styled.h3`
  font-size: calc(100vw * (18 / 375));
  font-weight: bold;
  letter-spacing: 0.25px;
  text-align: center;
  padding: calc(100vw * (20 / 375)) 0 calc(100vw * (12 / 375)) 0;
`;
const ModalContentInner = styled.p`

    white-space: pre-line;
  text-align: center;
  font-size: calc(100vw * (14 / 375));
  line-height: 1.43;
  letter-spacing: 0.2px;
  padding-bottom: calc(100vw * (16.5 / 375));
`;
